'use strict';

function updateActionButtons(content, prevButton, nextButton) {
    if (!prevButton || !nextButton) {
        return;
    }

    const maxScroll = Math.max(content.scrollWidth - content.clientWidth, 0);
    const position = Math.round(content.scrollLeft);
    const isAtStart = position <= 0;
    const isAtEnd = position >= Math.round(maxScroll);
    const isScrollable = maxScroll > 0;

    prevButton.toggleAttribute('disabled', !isScrollable || isAtStart);
    nextButton.toggleAttribute('disabled', !isScrollable || isAtEnd);

    prevButton.setAttribute('aria-disabled', String(!isScrollable || isAtStart));
    nextButton.setAttribute('aria-disabled', String(!isScrollable || isAtEnd));
}

function updateScrollbar(content, track, thumb) {
    const maxScroll = Math.max(content.scrollWidth - content.clientWidth, 0);
    const trackWidth = track.clientWidth;
    const thumbWidth = maxScroll > 0 ? Math.max((content.clientWidth / content.scrollWidth) * trackWidth, 64) : trackWidth;
    const maxOffset = Math.max(trackWidth - thumbWidth, 0);
    const progress = maxScroll > 0 ? content.scrollLeft / maxScroll : 0;

    track.hidden = maxScroll <= 0 || trackWidth <= 0;
    thumb.style.width = thumbWidth + 'px';
    thumb.style.transform = 'translateX(' + (maxOffset * progress) + 'px)';
}

function initScrollbar(container) {
    const widget = container.querySelector('.js-vviinn-widget');
    const track = container.querySelector('.js-product-scroll-indicator');
    const thumb = container.querySelector('.js-product-scroll-indicator-thumb');

    if (!widget || !track || !thumb || container.dataset.vviinnScrollbarReady === 'true') {
        return;
    }

    function connect() {
        const content = widget.shadowRoot && widget.shadowRoot.querySelector('.content');
        const prevButton = widget.shadowRoot && widget.shadowRoot.querySelector('button.prev');
        const nextButton = widget.shadowRoot && widget.shadowRoot.querySelector('button.next');

        if (!content) {
            return false;
        }

        const render = function () {
            window.requestAnimationFrame(function () {
                updateScrollbar(content, track, thumb);
                updateActionButtons(content, prevButton, nextButton);
            });
        };

        content.addEventListener('scroll', render, { passive: true });
        window.addEventListener('resize', render);

        if (window.ResizeObserver) {
            const resizeObserver = new ResizeObserver(render);

            resizeObserver.observe(content);
            resizeObserver.observe(track);
        }

        container.dataset.vviinnScrollbarReady = 'true';
        render();

        return true;
    }

    if (connect()) {
        return;
    }

    let attempts = 0;
    const intervalId = window.setInterval(function () {
        attempts += 1;

        if (connect() || attempts > 40) {
            window.clearInterval(intervalId);
        }
    }, 250);
}

module.exports = {
    init: function () {
        const containers = document.querySelectorAll('.js-vviinn-products');

        containers.forEach(function (container) {
            initScrollbar(container);
        });
    }
};
